<router-outlet></router-outlet>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#ccff00" type = "ball-climbing-dot" [fullScreen] = "true"><p style="color: white" > Cargando ... </p></ngx-spinner>
